var IncomingForm = require('./incoming_form').IncomingForm;
IncomingForm.IncomingForm = IncomingForm;
module.exports = IncomingForm;



/*****************
 ** WEBPACK FOOTER
 ** ./~/formidable/lib/index.js
 ** module id = 260
 ** module chunks = 0 1
 **/